/**
 * Impl dos use cases de Formulário (CRUD + perguntas; acadadmin).
 *
 * @since G.5.14
 */
import type { Page } from '@/domain/model/Page';
import type {
  Formulario, FormularioPergunta,
  CreateFormularioCommand, UpdateFormularioCommand, CreateFormularioPerguntaCommand,
} from '@/domain/model/Formulario';
import type { FormularioGateway, ListFormulariosParams } from '@/application/port/out/FormularioGateway';
import type {
  ListFormulariosUseCase, GetFormularioUseCase, CreateFormularioUseCase,
  UpdateFormularioUseCase, PublicarFormularioUseCase, ClonarFormularioUseCase,
  InativarFormularioUseCase, ListFormularioPerguntasUseCase,
  AddFormularioPerguntaUseCase, RemoverFormularioPerguntaUseCase,
} from '@/application/port/in/FormularioUseCase';

export class ListFormularios implements ListFormulariosUseCase {
  constructor(private readonly g: FormularioGateway) {}
  execute(params: ListFormulariosParams): Promise<Page<Formulario>> { return this.g.list(params); }
}
export class GetFormulario implements GetFormularioUseCase {
  constructor(private readonly g: FormularioGateway) {}
  execute(id: string): Promise<Formulario> { return this.g.get(id); }
}
export class CreateFormulario implements CreateFormularioUseCase {
  constructor(private readonly g: FormularioGateway) {}
  execute(cmd: CreateFormularioCommand): Promise<Formulario> { return this.g.create(cmd); }
}
export class UpdateFormulario implements UpdateFormularioUseCase {
  constructor(private readonly g: FormularioGateway) {}
  execute(id: string, cmd: UpdateFormularioCommand): Promise<Formulario> { return this.g.update(id, cmd); }
}
export class PublicarFormulario implements PublicarFormularioUseCase {
  constructor(private readonly g: FormularioGateway) {}
  execute(id: string): Promise<Formulario> { return this.g.publicar(id); }
}
export class ClonarFormulario implements ClonarFormularioUseCase {
  constructor(private readonly g: FormularioGateway) {}
  execute(id: string): Promise<Formulario> { return this.g.clonar(id); }
}
export class InativarFormulario implements InativarFormularioUseCase {
  constructor(private readonly g: FormularioGateway) {}
  execute(id: string): Promise<void> { return this.g.inativar(id); }
}
export class ListFormularioPerguntas implements ListFormularioPerguntasUseCase {
  constructor(private readonly g: FormularioGateway) {}
  execute(id: string): Promise<FormularioPergunta[]> { return this.g.listPerguntas(id); }
}
export class AddFormularioPergunta implements AddFormularioPerguntaUseCase {
  constructor(private readonly g: FormularioGateway) {}
  execute(id: string, cmd: CreateFormularioPerguntaCommand): Promise<FormularioPergunta> {
    return this.g.addPergunta(id, cmd);
  }
}
export class RemoverFormularioPergunta implements RemoverFormularioPerguntaUseCase {
  constructor(private readonly g: FormularioGateway) {}
  execute(id: string, perguntaId: string): Promise<void> { return this.g.removerPergunta(id, perguntaId); }
}
